import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MpsAuthService, MpsOauth2Service, MpsUserService } from '../../../../../mps/mps-auth';
import { MpsLoaderService } from '../../../../../mps/mps-loader';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResetPasswordLinkComponent } from '../reset-password-link/resetPasswordLink.component';
import { ResetPasswordComponent } from '../reset-password/resetPassword.component';
import { BehaviorSubject } from 'rxjs';
import {User} from 'src/app/models/user';

@Component({
  selector: 'app-auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public error: any;
  
  recaptcha: { siteKey, hl, type };

  /**
   * Reset password link modal
   */
  public showResetPasswordLinkModal: boolean;

  /**
   * Reset password modal
   */
  public showResetPasswordModal: boolean;

  public token: string;
  public email: string;

  constructor(
    private _authService: MpsAuthService,
    fb: FormBuilder,
    private _router: Router,
    private _userService: MpsUserService,
    private _activatedRoute: ActivatedRoute,
    private _matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _loaderService: MpsLoaderService,
    private _oauth2: MpsOauth2Service,
    private _matSnackbar: MatSnackBar
  ) {
      
    this.error = {};

    this.loginForm = fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      captcha_token: ['']
    });

    this.showResetPasswordLinkModal = false;

    this._activatedRoute.queryParams.subscribe(
      (params: any) => {
        if (params.token) {
            this.token = params.token;
            this.email = params.email;
          
            this.showResetPasswordDialog();
        }
      }
    );
    
    this._activatedRoute.queryParams.subscribe(
        (params: any) => {
            const token = params._error;
            if (token) {
                this._matSnackbar.open(params._error);
            }
        }
    );
    
    let user = new User(this._userService.getUser().getValue());

    if (this._userService.getUser().getValue()) {
        if (user.isAdmin() || user.isReferent() || user.isRH()) {
            this._router.navigate(['/secondees-list']);
        } else {
            this._router.navigate(['/interview/' + user.secondee?.id + '/form']); // Pas de formulaire ou poser question
        }
    }
  }

  public loginWithOAuth2(url: string) {

    this._loaderService.show();
    this._oauth2.login(url).then(
      (user: any) => {
        this._loaderService.hide();
      }
    );
  }

  public getOAuth2Providers(): BehaviorSubject<any> {
    return this._oauth2.getProviders();
  }

  public redirect(url: string) {
    window.location.href = url;
  }

  public login(form: FormGroup) {

    // Prevent spam submit
    if (form.valid && !this._loaderService.isVisible()) {

      // this._loaderService.show();

      this._authService.login(form).then(
        (user: any) => {
          this._loaderService.hide();
          window.location.reload();
        }
      ).catch(
        (response) => {
          this._loaderService.hide();
          this._snackBar.open(response.error.message, 'Close', {
            duration: 3000
          });
        }
      );

    }
  }

  public showResetPasswordLinkDialog() {
    this._matDialog.open(ResetPasswordLinkComponent);
  }

  public showResetPasswordDialog() {

    this._matDialog.open(ResetPasswordComponent, {
      data: { token: this.token , email: this.email }
    });
  }

  ngOnInit() {
  }

}
